var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.showLabel ? "requests-table" : "bulk-table" }, [
    _vm.showLabel ? _c("label", [_vm._v("Leistungen:")]) : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.showStatusFilter
          ? _c("div", { staticClass: "bulk-status-filter" }, [
              _c(
                "div",
                { staticClass: "buttons has-addons" },
                _vm._l(_vm.statusFilters, function (filter) {
                  return _c(
                    "button",
                    {
                      key: filter.key,
                      staticClass: "button",
                      class: { "is-primary": _vm.statusFilter === filter.key },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.statusFilter = filter.key
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(filter.label) + " (" + _vm._s(filter.count) + ")"
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "buttons has-addons" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: {
                      title: "Alle aktuell sichtbaren Requests auswählen",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.selectVisible.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Sichtbare auswählen")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.clearSelection.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Auswahl leeren")]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("edit-table", {
          ref: "table",
          staticClass: "requests-edit-table is-mobile-scrollable",
          attrs: {
            rows: _vm.requests,
            columns: _vm.columns,
            load: false,
            "load-options": false,
            "delete-row": false,
            footer: false,
            "hide-filter-row": true,
            "is-zebra": false,
            name: { singular: "Leistung", plural: "Leistungen" },
          },
          scopedSlots: _vm._u([
            {
              key: "head",
              fn: function () {
                return [
                  _c("div", { staticClass: "row is-head" }, [
                    _c(
                      "div",
                      {
                        staticClass: "cell is-icon-cell is-centered has-border",
                        staticStyle: { padding: "0" },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkAll,
                              expression: "checkAll",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.checkAll)
                              ? _vm._i(_vm.checkAll, null) > -1
                              : _vm.checkAll,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.checkAll,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.checkAll = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkAll = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkAll = $$c
                              }
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "cell is-pure-text has-border is-grow-cell",
                      },
                      [_vm._v("Leistung")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "cell is-150px-cell is-pure-text has-border",
                      },
                      [_vm._v("Datum")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "cell is-100px-cell is-pure-text has-border",
                      },
                      [_vm._v("Status")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "cell is-100px-cell is-pure-text has-border",
                      },
                      [_vm._v("Details")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "cell is-130px-cell is-pure-text has-border",
                      },
                      [_vm._v("Deadline")]
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "default",
              fn: function () {
                return [
                  _vm.visibleRequests.length === 0
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "cell has-text-centered",
                            staticStyle: { "flex-grow": "1" },
                          },
                          [
                            _vm.statusFilter !== "all"
                              ? [_vm._v("Keine Leistungen mit diesem Status")]
                              : [_vm._v("Keine Leistungen gefunden")],
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.orderGroups, function (orderGroup) {
                    return [
                      orderGroup.headline ||
                      (orderGroup.orderId &&
                        (_vm.groupBy === "order" || _vm.orderGroups.length > 1))
                        ? _c(
                            "div",
                            {
                              key:
                                "order-" +
                                (orderGroup.headline || orderGroup.orderId),
                              staticClass: "row is-headline not-white",
                            },
                            [
                              _c("div", {
                                staticClass: "cell is-icon-cell is-centered",
                                staticStyle: { padding: "0" },
                              }),
                              _vm._v(" "),
                              orderGroup.headline
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cell is-pure-text is-grow-cell",
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(_vm._s(orderGroup.headline)),
                                      ]),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cell is-pure-text is-grow-cell",
                                    },
                                    [_vm._v("# " + _vm._s(orderGroup.orderId))]
                                  ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(orderGroup.groups, function (group) {
                        return [
                          group.label
                            ? _c(
                                "div",
                                {
                                  key: group.key,
                                  staticClass:
                                    "row is-headline is-placeholder not-white",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cell is-icon-cell is-centered has-border",
                                      staticStyle: { padding: "0" },
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          title:
                                            "Alle Requests dieses Platzhalters auswählen",
                                        },
                                        domProps: {
                                          checked: _vm.isGroupChecked(group),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkGroup(group)
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cell is-pure-text has-border is-grow-cell",
                                    },
                                    [
                                      _vm.typeIcons[group.requestType]
                                        ? _c(
                                            "i",
                                            {
                                              staticClass: "material-icons m-r",
                                              attrs: {
                                                title:
                                                  _vm.typeIcons[
                                                    group.requestType
                                                  ].title,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.typeIcons[
                                                    group.requestType
                                                  ].icon
                                                )
                                              ),
                                            ]
                                          )
                                        : _c("other-service-icons", {
                                            staticClass: "m-r",
                                            attrs: {
                                              type: group.otherServiceCategory,
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c(
                                        "b",
                                        {
                                          staticClass: "is-truncated",
                                          attrs: { title: group.label },
                                        },
                                        [_vm._v(_vm._s(group.label))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cell is-150px-cell is-pure-text has-border is-ellipsis",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateRange(
                                            group.startAt,
                                            group.endAt
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "cell is-100px-cell has-border",
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "cell is-100px-cell has-border",
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "cell is-130px-cell has-border",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(group.requests, function (request) {
                            return _c(
                              "div",
                              { key: request.id, staticClass: "row" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cell is-icon-cell is-centered has-border",
                                    staticStyle: { padding: "0" },
                                  },
                                  [
                                    _c("input", {
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: _vm.isChecked(request),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.check(request)
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cell is-pure-text has-border is-grow-cell",
                                    attrs: { title: request.info.title },
                                  },
                                  [
                                    _vm.groupBy === "order"
                                      ? [
                                          _vm.typeIcons[request.requestType]
                                            ? _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons m-r",
                                                  attrs: {
                                                    title:
                                                      _vm.typeIcons[
                                                        request.requestType
                                                      ].title,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.typeIcons[
                                                        request.requestType
                                                      ].icon
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c("other-service-icons", {
                                                staticClass: "m-r",
                                                attrs: {
                                                  type: request.otherServiceType
                                                    .category,
                                                },
                                              }),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "is-truncated" },
                                      [
                                        _vm.groupBy === "provider"
                                          ? [
                                              _vm._v(
                                                "# " +
                                                  _vm._s(request.orderID) +
                                                  " " +
                                                  _vm._s(
                                                    request.info.clientShortName
                                                  ) +
                                                  " – "
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(_vm._s(request.info.title)),
                                      ],
                                      2
                                    ),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cell is-150px-cell is-pure-text has-border is-ellipsis",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dateRange(
                                          request.info.startAt,
                                          request.info.endAt
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cell is-100px-cell is-pure-text has-border is-ellipsis",
                                  },
                                  [
                                    _vm.options
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getValueWithKey({
                                                key: request.requestStatus
                                                  .status,
                                                optionList: _vm.options.status,
                                              })
                                            )
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cell is-100px-cell is-pure-text has-border is-ellipsis",
                                  },
                                  [
                                    request.requestType === "hotel" &&
                                    _vm.options
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getValueWithKey({
                                                key: request.board,
                                                optionList:
                                                  _vm.options.boardList,
                                              })
                                            )
                                          ),
                                        ]
                                      : request.requestType === "ferry"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              request.type === "night"
                                                ? "Nachtfähre"
                                                : "Tagfähre"
                                            )
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cell is-130px-cell is-pure-text has-border is-ellipsis",
                                  },
                                  [
                                    request.optionTodo &&
                                    request.optionTodo.dueDate
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              "deadline-date",
                                              _vm.deadlineUrgency(
                                                request.optionTodo.dueDate
                                              ),
                                            ],
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("notifications_none")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("fullYear")(
                                                    request.optionTodo.dueDate
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ]
                      }),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }